import { Component, OnDestroy, OnInit } from '@angular/core';
import {PreorderArchiveService} from "./services/preorder-archive.service";
import {UserService} from "../../core/user/services/user.service";
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {PdfService} from "../../core/export/pdf.service";
import {AccountService} from "../../core/account/services/account.rest.service";
import {PreorderArchivedItemModel} from "./models/preorder-archive-item.model";

@Component({
  selector: 'app-preorders-archive',
  standalone: false,
  templateUrl: './preorders-archive.component.html',
  styleUrl: './preorders-archive.component.scss'
})

export class PreordersArchiveComponent implements OnDestroy, OnInit{
  protected preordersArchive: any[] = [];
  private ngUnsubscribe$ = new Subject<void>();
  displayedColumns: string[] = ['vendor', 'idf', 'period_start', 'period_end', 'delivery_from', 'download',];
  private selectedPreorderData: any[] = [];
  accountData: any[] = [];
  selectedIdf: any;

  grippeVendorDeliveryText: Record<string, string> = {
      'CSL SEQIRUS': 'KW 34/35, KW 36/38',
      'GSK': 'KW 38/40, KW 42/43',
      'Sanofi': 'KW 37/38, KW 40, KW 42/43',
      'Mylan/Viatris': 'KW 36/37, KW 39, KW 42/44'
  };

  constructor(private preordersArchiveService: PreorderArchiveService,
              private exportPdfService: PdfService,
              private userService: UserService,
              private accountService: AccountService) {
    this.userService.selectedIdf$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(idf => {

      if (idf) {
        this.selectedIdf = idf;
        this.getPreordersArchive(this.selectedIdf)
      }
    });
  }
  ngOnInit() {
    // this.userService.selectedIdf$.subscribe(idf => {
    //   if (idf) {
    //     this.selectedIdf = idf;
    //     this.getPreordersArchive(this.selectedIdf)
    //   }
    // });
  }

  getPreordersArchive($event: any) {
    this.loadShippingAddress($event);
    this.preordersArchiveService.loadPreordersArchive($event).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((result: any) => {
      this.preordersArchive = result.return_object;
      console.log('Preorders Archive:', this.preordersArchive);
    })
  }

  loadShippingAddress(idf: string) {
    this.accountService.getShippingAddress(idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response: any) => {
        this.accountData = response.return_object;
      }
    );
  }

  getPreorder(preorderItem: any) {
    this.selectedPreorderData = [];
    this.preordersArchiveService.loadPreorderItems(preorderItem.idf, preorderItem.pre_order_id)
    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((items: any) => {
      this.selectedPreorderData = items.return_object;

      const cols: any[] = ['PZN', 'Artikel', 'Bestellmenge\n' + 'Pck.', 'Impfstoffdosen\n' + 'Stk.'];
      const rows: any[] = [];
      const title = 'Bestelleingangsbestätigung\n\n';
      const desc = 'Sehr geehrte Damen und Herren,\n\n' + 'hiermit bestätigen wir Ihnen nachstehende Vorbestellung:\n';
      const fileName = `${preorderItem.idf}_vorbestellung_${preorderItem.vendor}_grippeimpfstoffe`;
      let totalQuantity = 0;

      this.selectedPreorderData.forEach((element: PreorderArchivedItemModel) => {
        let temp: any[];
        const pzn = element.pzn,
          artikel = element.name + ' - ' + element.unit,
          bestellmenge: number = element.quantity !== null ? element.quantity : 0,
          impfstoffdosen: number = parseInt(element.unit, 10) * element.quantity;
        temp = [
          pzn,
          artikel,
          bestellmenge,
          impfstoffdosen
        ];
        rows.push(temp);
        totalQuantity += parseInt(element.unit, 10) * element.quantity;
      });
      const footerTitle = `Ihre Vorbestellung von ${preorderItem.vendor} Impfstoffdosen: ${totalQuantity}`;
      const footerDesc = 'Auslieferung nach Chargenfreigabe durch das Paul-Ehrlich-Institut unter dem Vorbehalt rechtzeitiger, richtiger Selbstbelieferung (somit Auslieferung an Sie nach erfolgtem Wareneingang bei uns).\n\nGrippe-Impfstoffe sind von der Retoure ausgeschlossen. Lieferung in apothekenüblichen Mengen, solange Vorrat reicht. Ergänzend gelten unsere Verkaufs- und Lieferbedingungen. Die Auslieferung der Impfstoffe erfolgt in der Reihenfolge des Bestelleingangs.';
      const account: any = this.accountData;

      let address = `${account.owner ? account.owner : null}\n${account.pharmacy ? account.pharmacy : null}\n${account.street ? account.street : null}\n${account.zip_code ? account.zip_code : null} ${account.city ? account.city : null}`;
      // using '' in string concatenation keeps an empty space so we use null and then replace all null
      address = address.replace(/null /g, '');
      const data: any = {
        desc: desc,
        footerTitle: footerTitle,
        footerDesc: footerDesc,
        date: preorderItem.pre_order_initiated_at
      };

      this.exportPdfService.exportToPdf(cols, rows, fileName, title, address, data);
    });
  }

  getDeliveredFrom(element: any, groupTitle: string): string {
    if (groupTitle !== 'Grippe Vorbestellung 2026') {
      return '';
    }
    return this.grippeVendorDeliveryText[element.vendor] ?? '';
  }

  /**
   * Unsubscribe from all subscriptions.
   */

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}
